const trustItems = [
  {
    icon: 'ri-tools-line',
    title: 'Orijinal Yedek Parça',
    desc: 'Aracınıza uygun, kaliteli ve orijinal yedek parça seçenekleri.',
  },
  {
    icon: 'ri-customer-service-line',
    title: 'Hızlı İletişim',
    desc: 'WhatsApp ve telefon üzerinden anında bilgi ve destek.',
  },
  {
    icon: 'ri-truck-line',
    title: '81 İle Kargo',
    desc: 'Türkiye’nin 81 iline güvenilir kargo gönderimi.',
  },
  {
    icon: 'ri-battery-charge-line',
    title: 'Akü ve Yol Yardım Desteği',
    desc: 'Silivri – Tekirdağ hattında yerinde akü takviye ve yol yardım.',
  },
];

export default function TrustSection() {
  return (
    <section id="neden-biz" className="relative bg-brand-darker py-20 md:py-28">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
            Neden Silivri Oto Yedek Parça?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 bg-brand-surface rounded-2xl p-5 md:p-6 border border-white/10 hover:border-brand-accent/30 transition-colors shadow-lg shadow-black/20"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-brand-accent/10 shrink-0">
                <i className={`${item.icon} text-xl md:text-2xl text-brand-accent`}></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-sm md:text-base mb-1">
                  {item.title}
                </h3>
                <p className="text-brand-muted text-xs md:text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}